import {
  Box,
  Typography,
  makeStyles,
  TextField,
  Button,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup,
} from "@material-ui/lab";
import { useState } from "react";

//import FullAddressInput from "../../../components/FullAddressInput";
import { converttoWgGender, converttoWgPhoneFormat } from "../../../utils";
import { useTranslate } from "react-admin";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    marginTop: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: "bolder",
    color: theme.darkGray,
    marginBottom: 10,
  },
  container: {
    position: "relative",
    boxSizing: "border-box",

    paddingTop: 19,
    paddingBottom: 0,
    borderRadius: 12,
    backgroundColor: theme.lightGray2,
    marginBottom: 10,
  },
  contentText: {
    fontSize: 16,
  },
  editIcon: {
    position: "absolute",
    top: 11,
    right: 17,
    color: theme.orange,
  },
  removeIcon: {
    position: "absolute",
    top: 11,
    right: 64,
    color: theme.orange,
  },
  deleteBoxContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "50% 50%",
    placeItems: "center",

    backgroundColor: theme.pureWhite + "aa",
    borderColor: theme.red,
    borderWidth: 3,
  },
  deleteBoxCancelButton: {
    width: 160,
    height: 44,
    borderRadius: 12,
    backgroundColor: theme.darkGray,
    color: theme.white,
    fontSize: 20,
  },
  deleteBoxDeleteButton: {
    width: 160,
    height: 44,
    borderRadius: 12,
    backgroundColor: theme.red,
    color: theme.white,
    fontSize: 20,
  },
  row: {
    display: "grid",
    boxSizing: "border-box",
    paddingLeft: 26,
    paddingRight: 26,
    gridTemplateColumns: "150px 400px",
    gridRowGap: 25,
    rowGap: 25,
    width: "inherit",
    alignItems: "center",
  },
  cancelandSaveoContainer: {
    marginTop: 20,
    display: "grid",
    gridTemplateColumns: "50% 50%",
  },
  bigButton: { fontSize: 20, borderRadius: 0 },
  addButton: { width: "100%", borderColor: theme.orange, color: theme.orange },
}));
const InfoBlock = ({
  title,
  contents,
  onSave,
  isArray,
  groupKey,
  noEdit,
  address,
  allowWrite,
}) => {
  const classes = useStyles();

  if (isArray && !groupKey) {
    alert("groupKey is missing");
    return null;
  }
  if (!allowWrite) noEdit = true;

  return (
    <Box className={classes.allContainer}>
      <Title title={title} />
      {isArray ? (
        <ContentArrayBox
          contents={contents}
          onSave={onSave}
          isArray={isArray}
          groupKey={groupKey}
          noEdit={noEdit}
        />
      ) : (
        <ContentBox
          contents={contents}
          onSave={onSave}
          isArray={isArray}
          groupKey={groupKey}
          noEdit={noEdit}
          address={address}
        />
      )}
    </Box>
  );
};

const Title = ({ title }) => {
  const classes = useStyles();
  return <Typography className={classes.title}>{title}</Typography>;
};

const ContentArrayBox = ({ contents, onSave, isArray, groupKey, noEdit }) => {
  const classes = useStyles();
  const editNum = contents[0].values?.length ?? 0;
  let defaultEditArray = [];

  const [deleteModeIndex, setDeleteModeIndex] = useState(-1);

  for (let i = 0; i < editNum; i++) {
    defaultEditArray.push(false);
  }
  const [editMode, setEditMode] = useState(defaultEditArray);
  const [showAddBox, setShowAddBox] = useState(false);
  return (
    <>
      {contents[0]?.values?.map((val, index) => {
        return !editMode[index] ? (
          <Box style={{ position: "relative" }} key={"b" + index}>
            <ViewBox
              contents={contents}
              onEdit={() => {
                editMode[index] = true;
                const newEditMode = [...editMode];
                setEditMode(newEditMode);
              }}
              onDelete={() => setDeleteModeIndex(index)}
              isArray={isArray}
              index={index}
              noEdit={noEdit}
            />
            {deleteModeIndex === index ? (
              <DeleteBox
                onCancel={() => setDeleteModeIndex(-1)}
                onDelete={() => {
                  const newContentValues = [
                    ...contents[0].values.filter((_, i) => i !== index),
                  ];
                  return onSave({ [groupKey]: newContentValues });
                }}
              />
            ) : null}
          </Box>
        ) : (
          <EditBox
            contents={contents}
            onSave={(data) => {
              const beforeSpread = { ...contents[0].values[index] };
              const newValue = { ...beforeSpread, ...data };
              contents[0].values[index] = { ...newValue };
              const newArray = [...contents[0].values];

              return onSave({ [groupKey]: newArray });
            }}
            onCancel={() => {
              editMode[index] = false;
              const newEditMode = [...editMode];
              setEditMode(newEditMode);
            }}
            isArray={isArray}
            index={index}
          />
        );
      })}
      <Box className={classes.container} marginTop={"5px"}>
        {showAddBox ? (
          <AddBox
            contents={contents}
            groupKey={groupKey}
            onSave={onSave}
            onCancel={() => setShowAddBox(false)}
          />
        ) : (
          <Button
            className={classes.addButton}
            variant="outlined"
            onClick={() => setShowAddBox(true)}
          >
            Add
          </Button>
        )}
      </Box>
    </>
  );
};

const ContentBox = ({ contents, onSave, isArray, noEdit, address }) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <>
      {editMode ? (
        <EditBox
          contents={contents}
          onSave={onSave}
          onCancel={() => setEditMode(false)}
          isArray={isArray}
          address={address}
        />
      ) : (
        <ViewBox
          contents={contents}
          onEdit={() => setEditMode(true)}
          isArray={isArray}
          noEdit={noEdit}
          address={address}
        />
      )}
    </>
  );
};

const DeleteBox = ({ onCancel, onDelete }) => {
  const classes = useStyles();
  return (
    <Box className={classes.deleteBoxContainer}>
      <Button
        className={classes.deleteBoxCancelButton}
        variant="contained"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        className={classes.deleteBoxDeleteButton}
        onClick={onDelete}
        variant="contained"
      >
        Delete
      </Button>
    </Box>
  );
};

const AddBox = ({ contents, onCancel, onSave, groupKey }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [data, setData] = useState({});
  return (
    <>
      <Box className={classes.row}>
        <EditBoxContent contents={contents} data={data} setData={setData} />
      </Box>
      <Box className={classes.cancelandSaveoContainer}>
        <BigButton color={"secondary"} onClick={onCancel} leftRound>
          {translate("ra.action.cancel")}
        </BigButton>
        <BigButton
          rightRound
          color={"primary"}
          onClick={() => {
            const oldData = contents[0].values ?? [];
            return onSave({ [groupKey]: [...oldData, data] });
          }}
        >
          {translate("ra.action.save")}
        </BigButton>
      </Box>
    </>
  );
};

const ViewBox = ({ contents, onEdit, onDelete, isArray, index, noEdit }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.row}>
        {contents.map((content) => {
          let displayValue;
          if (!content) return null;
          if (isArray) {
            if (content.selectDisplayValueFunctionforIsArray) {
              displayValue = content.selectDisplayValueFunctionforIsArray(
                content.values[index][content.key]
              );
              //displayValue = content.values[index][content.valueProperty];
            } else displayValue = content.values[index][content.key];
          } else displayValue = content?.value;

          if (content.type === "date") {
            displayValue = changeWGDatetoViewBoxFormat(displayValue);
          }

          if (content.type === "textarray") {
            displayValue = displayValue?.join(", ") ?? "";
          }

          if (content.type === "select") {
            //alert(content.value);
            const foundOption = content.options.find(
              (option) => option.id === content.value
            );
            if (foundOption) displayValue = foundOption[content.valueProperty];
            else displayValue = "";
          }

          if (content.key === "phone") {
            //extra
            if (displayValue) displayValue = displayValue.split("|")[0];
          }
          return (
            <>
              <Typography className={classes.contentText}>
                {content.text}
              </Typography>
              <Typography className={classes.contentText}>
                {displayValue}
              </Typography>
            </>
          );
        })}
      </Box>
      <Box height={26} />
      {isArray ? (
        <DeleteIcon className={classes.removeIcon} onClick={onDelete} />
      ) : null}
      {noEdit ? null : (
        <EditIcon className={classes.editIcon} onClick={onEdit} />
      )}
    </Box>
  );
};

const EditBox = ({ contents, onCancel, onSave, isArray, index, address }) => {
  const classes = useStyles();
  const translate = useTranslate();

  const [data, setData] = useState(
    contents.reduce((obj, content, index) => {
      if (!content) return { ...obj };

      if (isArray) {
        obj[content.key] = content.values[index][content.key];
        return { ...obj };
      }
      if (content.type === "select") {
        obj[content.key] = content.id;
        return { ...obj };
      }

      obj[content.key] = content.value;
      return { ...obj };
    }, {})
  );

  const handleNonArraySave = () => {
    let submitData = Object.entries(data).reduce((obj, [key, value]) => {
      const keys = key.split(".");
      if (keys.length === 3) {
        if (obj[keys[0]]) {
          if (obj[keys[0]][keys[1]]) {
            if (obj[keys[0]][keys[1]][keys[2]]) {
              obj[keys[0]][keys[1]][keys[2]] = value;
            } else {
              obj[keys[0]][keys[1]] = {
                [keys[2]]: value,
                ...obj[keys[0]][keys[1]],
              };
            }
          } else {
            obj[keys[0]] = {
              [keys[1]]: { [keys[2]]: value },
              ...obj[keys[0]],
            };
          }
        } else {
          obj = { [keys[0]]: { [keys[1]]: { [keys[2]]: value } } };
        }

        obj = { ...obj };

        if (key === "i18n.en-US.firstname") {
          obj = { ...obj, firstname: value };
        }

        if (key === "i18n.en-US.lastname") {
          obj = { ...obj, lastname: value };
        }
        return obj;
      }
      if (key === "gender") {
        return { ...obj, [key]: converttoWgGender(value) };
      }

      if (key === "phone") {
        return { ...obj, [key]: converttoWgPhoneFormat(value) };
      }

      return { ...obj, [key]: value };
    }, {});

    contents.forEach((content) => {
      if (content.type === "textarray") {
        if (submitData[content.key])
          submitData[content.key] = [
            ...submitData[content.key]?.filter((data) => data !== ""),
          ];
      }
      if (content.type === "date") {
        if (submitData[content.key])
          submitData[content.key] = changeLocaltoWGformat(
            submitData[content.key]
          );
      }
    });
    return onSave(submitData);
  };

  // const onAddressChangeHandler = () => {};
  // const provinceId = contents.find((c) => c.key === "province_id").value
  // contents.find((c) => c.key === "province_id").options.find(opt => opt.id);

  return (
    <Box className={classes.container}>
      <Box className={classes.row}>
        <EditBoxContent contents={contents} data={data} setData={setData} />
      </Box>
      <Box className={classes.cancelandSaveoContainer}>
        <BigButton color={"secondary"} onClick={onCancel} leftRound>
          {translate("ra.action.cancel")}
        </BigButton>
        <BigButton
          rightRound
          color={"primary"}
          onClick={() => {
            if (isArray) {
              let submitData = { ...data };

              contents.forEach((content) => {
                if (content.type === "textarray") {
                  if (submitData[content.key])
                    submitData[content.key] = [
                      ...submitData[content.key]?.filter((data) => data !== ""),
                    ];
                }
                if (content.type === "date") {
                  if (submitData[content.key])
                    submitData[content.key] = changeLocaltoWGformat(
                      submitData[content.key]
                    );
                }
              });

              onSave(submitData);
            } else handleNonArraySave();
          }}
        >
          {translate("ra.action.save")}
        </BigButton>
      </Box>
    </Box>
  );
};

const EditBoxContent = ({ contents, data, setData }) => {
  const classes = useStyles();

  return contents.map((content) => {
    if (!content) return null;

    if (content.type === "radio") {
      if (content.options[0].code) {
        //Do nothing
      } else {
        content.options = content.options.map((opt) => ({
          code: opt,
          name: opt,
        }));
      }
    }

    return (
      <>
        <Typography className={classes.contentText}>{content.text}</Typography>
        {content.type === "text" ? (
          <EditTextField
            key="ed01"
            value={
              !data
                ? ""
                : content.key === "phone"
                ? data[content.key]?.split("|")[0]
                : data[content.key]
            }
            onChange={(value) => setData({ ...data, [content.key]: value })}
          />
        ) : content.type === "radio" ? (
          <EditToggle
            key="ed02"
            value={data[content.key]}
            options={content.options}
            onChange={(value) => {
              setData({ ...data, [content.key]: value });
            }}
          />
        ) : content.type === "select" ? (
          <EditSelect
            key="ed03"
            options={getEditSelectOptions(content, data, contents)}
            valueProperty={content.valueProperty}
            defaultValue={content.options.find(
              (option) => option.id === content.value
            )}
            onChange={(value) => {
              setData({ ...data, [content.key]: value });
            }}
            label={null}
          />
        ) : content.type === "date" ? (
          <EditDate
            key="ed04"
            value={changeWGDateformattoLocal(data[content.key])}
            onChange={(value) =>
              setData({
                ...data,
                [content.key]: value,
              })
            }
          />
        ) : content.type === "textarray" ? (
          <EditTextArray
            key="ed05"
            value={data[content.key]}
            onChange={(changedArr) =>
              setData({ ...data, [content.key]: [...changedArr] })
            }
          />
        ) : content.type === "noedit" ? (
          <NoEditTextField value={data[content.key]} />
        ) : (
          <Typography className={classes.contentText}>
            {content.value}
          </Typography>
        )}
      </>
    );
  });
};

const EditTextField = ({ value, onChange }) => {
  return (
    <TextField
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

const NoEditTextField = ({ value }) => {
  return <TextField variant="outlined" value={value} disabled />;
};

const EditToggle = ({ options, value, onChange }) => {
  return (
    <ToggleButtonGroup
      value={value}
      onChange={(_, value) => onChange(value)}
      exclusive
    >
      {options?.map((option) => (
        <ToggleButton value={option.code}>{option.name}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

const EditSelect = ({
  options,
  valueProperty,
  defaultValue,
  onChange,
  label,
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      classes={{ root: classes.autocomplete }}
      options={options}
      getOptionLabel={(option) => {
        return option[valueProperty];
      }}
      onChange={(_, value) => onChange(value.id)}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          classes={{ root: classes.textfield }}
          placeholder={label}
          {...params}
        />
      )}
    />
  );
};

const EditDate = ({ value, onChange }) => {
  return (
    <TextField
      variant="outlined"
      type="date"
      format={"DD/MM/YYYY"}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      // InputProps={{
      //   inputComponent: InputComponent,
      // }}
    />
  );
};
// const useDateStyles = makeStyles((theme) => ({
//   root: {
//     position: "relative",
//   },
//   display: {
//     position: "absolute",
//     top: 2,
//     left: 0,
//     bottom: 2,
//     background: "white",
//     pointerEvents: "none",
//     right: 50,
//     display: "flex",
//     alignItems: "center",
//   },
//   input: {},
// }));
// function InputComponent({ defaultValue, inputRef, ...props }) {
//   const classes = useDateStyles();
//   const [value, setValue] = useState(() => props.value || defaultValue);

//   const handleChange = (event) => {
//     setValue(event.target.value);
//     if (props.onChange) {
//       props.onChange(event);
//     }
//   };

//   return (
//     <div className={classes.root}>
//       <div className={classes.display}>{value}</div>
//       <input
//         className={classes.input}
//         ref={inputRef}
//         {...props}
//         onChange={handleChange}
//         value={value}
//       />
//     </div>
//   );
// }

const fillArray = (max, length, value) => {
  for (let i = 0; i < max - length; i++) {
    value.push("");
  }
  return value;
};

const EditTextArray = ({ max = 3, value, onChange }) => {
  const [localValues, setLocalValue] = useState(
    value
      ? value.length < max
        ? fillArray(max, value.length, value)
        : value
      : ["", "", ""]
  );

  return (
    <Box style={{ display: "flex" }}>
      {localValues.map((data, index) => {
        return (
          <TextField
            variant="outlined"
            value={localValues[index]}
            onChange={(e) => {
              // 1. Make a shallow copy of the items
              let items = [...localValues];
              // 2. Make a shallow copy of the item you want to mutate
              let item = localValues[index];
              // 3. Replace the property you're intested in
              item = e.target.value;
              // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
              items[index] = item;
              // 5. Set the state to our new copy
              setLocalValue(items);
              onChange(items);
            }}
          />
        );
      })}
    </Box>
  );
};

const BigButton = ({
  color,
  children,
  onClick,
  leftRound = false,
  rightRound = false,
}) => {
  const classes = useStyles();
  return (
    <Button
      onClick={onClick}
      className={classes.bigButton}
      variant="contained"
      color={color}
      style={
        leftRound
          ? { borderBottomLeftRadius: 12 }
          : rightRound
          ? { borderBottomRightRadius: 12 }
          : null
      }
    >
      {children}
    </Button>
  );
};

const changeWGDatetoViewBoxFormat = (date) => {
  const localFormat = changeWGDateformattoLocal(date);
  if (localFormat === "") return localFormat;
  //const localFormats = localFormat.split("-");
  return moment(date).format("DD MMM YYYY");
  //return `${localFormats[2]}/${localFormats[1]}/${localFormats[0]}`;
};

const changeWGDateformattoLocal = (data) => {
  if (!data) return "";
  //onst dateOnly = data.split("T")[0];

  return moment(data).format("YYYY-MM-DD"); //dateOnly;
};

const changeLocaltoWGformat = (data) => {
  if (!data) return null;
  return data;
};

const getEditSelectOptions = (content, data, allContents) => {
  if (!data) return null;
  if (content.key === "district_id") {
    let compare;
    if (data.province_id) compare = data.province_id;
    else {
      const province = allContents.find((c) => c.key === "province_id");
      if (province) compare = province.value;
      else compare = null;
    }
    return content.options.filter((opt) => opt.province_id === compare);
  } else if (content.key === "sub_district_id") {
    let compare;
    if (data.district_id) compare = data.district_id;
    else {
      const dis = allContents.find((c) => c.key === "district_id");
      if (dis) compare = dis.value;
      else compare = null;
    }
    return content.options.filter((opt) => opt.district_id === compare);
  } else if (content.key === "postcode_id") {
    let compare;
    if (data.sub_district_id) compare = data.sub_district_id;
    else {
      const dis = allContents.find((c) => c.key === "sub_district_id");
      if (dis) compare = dis.value;
      else compare = null;
    }
    return content.options.filter((opt) => opt.sub_district_id === compare);
  } else return content.options;
};

export default InfoBlock;
